import { Platform } from "react-native";

// Build-time flags: Expo inlines EXPO_PUBLIC_* values when bundling, so keep
// the direct `process.env.EXPO_PUBLIC_…` references.

// Fundraising is live on evt.live (/api/pledge/*). Web reads the flag from the
// Netlify build env; the apps include it (Android from 4.3.4, iOS from 4.3.0)
// unless a build sets the flag to "false".
export const DONATIONS_ENABLED =
  Platform.OS === "web"
    ? process.env.EXPO_PUBLIC_DONATIONS_ENABLED === "true"
    : process.env.EXPO_PUBLIC_DONATIONS_ENABLED !== "false";

export const DONATIONS_API_URL = (
  process.env.EXPO_PUBLIC_DONATIONS_API_URL || "https://evt.live"
).replace(/\/+$/, "");
